window.addEventListener('DOMContentLoaded', function () {
  const slideBtns = document.querySelectorAll('.custom-slide-arrow')
  for (const btn of slideBtns) {
    btn.addEventListener('click', function (e) {
      const currentSlide = btn.closest('.custom-slideshow--slide')
      const newSlide = btn
        .closest('.custom-slideshow')
        .querySelector(
          `.custom-slideshow--slide[data-slide="${btn.getAttribute(
            'data-slide'
          )}"]`
        )
      currentSlide.classList.remove('slide-visible')
      currentSlide.style.zIndex = -1
      newSlide.classList.add('slide-visible')
      newSlide.style.zIndex = 3
    })
  }
})
